import React from 'react';
import {
  UIActions,
  UIActionsContext
} from '../../../../data-catalog-shared';
import { ErrorListProvider } from './ErrorListProvider';
import { ErrorToasts } from './ErrorToasts';
import { RegisterErrorStoreInHost, RegisterErrorStoreInHostProps } from './RegisterErrorStoreInHost';

export type StandaloneErrorToastsProps =
  RegisterErrorStoreInHostProps & {
    readonly uiActions: UIActions;
  };

/**
 * This is a standalone component that stores AND displays errors. It creates a new error list context via the ErrorListProvider,
 * and provides register/unregister callbacks so that the host app can add errors to the list. It will also display the errors
 * as toasts.
 */
export function StandaloneErrorToasts(props: StandaloneErrorToastsProps): JSX.Element {
  return (
    <UIActionsContext.Provider value={props.uiActions}>
      <ErrorListProvider>
        <RegisterErrorStoreInHost
          registerErrorStore={props.registerErrorStore}
          unregisterErrorStore={props.unregisterErrorStore}
        />
        <ErrorToasts />
      </ErrorListProvider>
    </UIActionsContext.Provider>
  );
}
